import { render, staticRenderFns } from "./tagCreate.vue?vue&type=template&id=2c74e0fc&scoped=true&"
import script from "./tagCreate.vue?vue&type=script&lang=js&"
export * from "./tagCreate.vue?vue&type=script&lang=js&"
import style0 from "./tagCreate.vue?vue&type=style&index=0&id=2c74e0fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74e0fc",
  null
  
)

export default component.exports